import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'BlogSection' })((theme) => ({
    root: {
        display: 'flex',
        padding: 64,
        flexDirection: 'column',
        alignItems: 'center',
        gap: 64,
        borderRadius: 24,
        background: 'rgba(255, 255, 255, 0.03)',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            gap: 24,
            padding: '24px 16px'
        }
    },
    cards: {
        gap: 20,
        width: '100%',
        display: 'grid',
        gridTemplateRows: '1fr',
        gridTemplateColumns: 'repeat(3, 1fr)',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            gridTemplateColumns: '1fr'
        }
    },
    button: {
        height: 56,
        padding: '16px 32px',
        color: '#fff',
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '16px',
        borderRadius: 56,
        background: '#2D2D2D !important',
        '&:hover': {
            background: '#393939 !important'
        },
        '&:active': {
            background: '#232323 !important'
        },
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            width: '100%'
        }
    }
}));
